/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Styles
import { Title } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import { Column } from "components/styles";
//#endregion
//#region Components
import ActionButtons from "./components/ActionButtons/ActionButtons";
import StudentTableList from "./components/StudentTableList/StudentTableList";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import CustomButton from "components/CustomButton/CustomButton";
import PenalizeDialog from "views/Recursos/ResourcesLibrary/SchedulesWrapper/ReservationData/PenalizeDialog/PenalizeDialog";
import DialogSearchStudent from "views/components/DialogSearchStudent/DialogSearchStudent";
//#endregion
//#region Utils
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import useMainContext from "utils/context/useMainContext";
import {
    ACTION_TYPES,
    TITLES_OF_DIALOG_CONFIRMATION
} from "./utils/constants";
import usePrevious from "utils/hooks/usePrevious";
import useRemoveScrollByDialogs from "./utils/hooks/useRemoveScrollByDialogs";
import useAddStudent from "./utils/hooks/useAddStudent";
import useDeleteStudents from "./utils/hooks/useDeleteStudents";
import useTakeStudentsAttendance from "./utils/hooks/useTakeStudentsAttendance";
import usePenalizedStudents from "./utils/hooks/usePenalizeStudents";
import useActionTypes from "./utils/hooks/useActionTypes";
//#endregion

const StudentListReservationView = ({
    loadingRequest,
    reservation: {
        id,
        resource,
        student,
        finalized,
        penalizeData
    },
    reloadData, 
    adjustPopupPosition, 
    setMustConfirm
}) => {
    const mainContext = useMainContext();
    //#region States
    const [studentList, setStudentList] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [studentsSelectedToUse, setStudentsSelectedToUse] = useState([]);
    const [successToDoActionOnStudent, setSuccessToDoActionOnStudent] = useState(false);
    const [resolveType, setResolveType] = useState(null);
    //#endregion
    //#region Dialogs
    const dialogShowSearchStudent = useShowDialogAlert();
    const dialogShowSaveInformation = useShowDialogAlert();
    const dialogShowResolveRequest = useShowDialogAlert();
    const dialogShowNotActionForHavingAttendanceOrPenalty = useShowDialogAlert();
    //#endregion
    const prevStudentList = usePrevious(studentList);
    //#region Effects
    useEffect(() => {
        fillStudentList();
    }, []);
    useEffect(() => {
        if (studentList.length > 5 || prevStudentList?.length === studentList.length) 
            return;
        adjustPopupPosition();
    }, [studentList]);
    //#endregion
    //#region Functions
    const fillStudentList = () => {
        const { responsable, others } = student;
        setStudentList([
            responsable,
            ...others
        ]);
    }
    const studentIsSelected = student => {
        return selectedStudents.some(({ id }) => id === student.id);
    }
    const allStudentAreSelected = () => {
        return studentList.every(currentStudent => selectedStudents.some(({ id }) => currentStudent.id === id));
    }
    const getHasBeenSelectedResponsableStudent = () => {
        return selectedStudents.some(({ id }) => id === student.responsable.id);
    }
    const toggleAllStudentsSelection = () => {
        setSelectedStudents(allStudentAreSelected() ? [] : [...studentList]);
    }
    const toggleStudentSelected = student => {
        setSelectedStudents(
            studentIsSelected(student)
            ? selectedStudents.filter(({ id }) => id !== student.id)
            : [...selectedStudents, student]
        );
    }
    //#region Aplicar modificación de la lista
    const saveInformation = async () => {
        dialogShowSaveInformation.set(false);
        const doAction = {
            [ACTION_TYPES.TAKE_ATTENDANCE]: doRequestTakeStudentAttendance,
            [ACTION_TYPES.PENALIZE]: doRequestPenalizeStudents,
            [ACTION_TYPES.DELETE]: doRequestDeleteStudentFromReservationList,
            [ACTION_TYPES.ADD]: doRequestAddStudentToReservationList
        };
        if (actionTypeList.value.length === 0)
            return;
        try {
            for (const actionType of actionTypeList.value) {
                await doAction[actionType]();
            }
            reloadData({
                messageForToast: "¡Se guardó exitosamente el cambio en la reserva!"
            });
        }
        catch (isUnexpectedError) {
            if (isUnexpectedError)
                mainContext.setShowDialogUnexpectedError(true);
        }
    }
    //#endregion
    const renderDialogAction = ({
        dialog,
        title, content, 
        contentComponent,
        buttons
    }) => {
        if (!dialog) return null;
        return (
            <DialogAlertAction
                show={dialog.value}
                toggleShow={dialog.toggle}
                width="700px"
                widthContent="100%"
                variant="secondary"
                title={title}
                content={content}
                contentComponent={contentComponent}>
                {buttons}
            </DialogAlertAction>
        );
    }
    const getHeaderTextsForDialogResolve = () => {
        if (!dialogShowResolveRequest.value) 
            return {};
        switch (resolveType) {
            case ACTION_TYPES.ADD:
                const studentSelectedToUse = studentsSelectedToUse[0];
                return successToDoActionOnStudent 
                    ? {
                        title: `Se agregó a ${studentSelectedToUse.id} (${studentSelectedToUse.name})
                        de la reserva del recurso ${resource.name}`,
                        content: "Podrás visualizarlo nuevamente en el listado de alumnos."
                    }
                    : {
                        title: `No se puede agregar a ${studentSelectedToUse.id} (${studentSelectedToUse.name})`,
                        content: "Porque ya forma parte de la misma reserva.",
                    };
            case ACTION_TYPES.DELETE:
                return successToDoActionOnStudent 
                    ? studentsSelectedToUse.length === 1  
                        ? {
                            title:`Se eliminó a ${studentsSelectedToUse[0].id} (${studentsSelectedToUse[0].name}) de la reserva del recurso ${resource.name}`,
                            content: "Recuerda que al eliminar un alumno, podrás agregarlo nuevamente a esta u otra reserva desde el botón agregar alumno(s)."
                        }
                        : {
                            title: `Se eliminó a los alumnos(as) de la reserva del recurso ${resource.name}`,
                            contentComponent: (
                                <>
                                <p className="paragraph center">
                                    Recuerda que al eliminar un alumno, podrás agregarlo nuevamente a esta u otra reserva desde el botón agregar alumno(s).<br/><br/>
                                    Alumnos(as) eliminados(as):
                                </p>
                                <Column
                                    className="custom-scrollbar secondary"
                                    maxHeight="150px"
                                    align="center">
                                    <ul className="list">
                                        {studentsSelectedToUse
                                        .map(({ id, name }) => (
                                            <li key={id} className="paragraph center">{id} ({name})<br/></li>
                                        ))}
                                    </ul>
                                </Column>
                                </>
                            )
                        }
                    : {}
            default: return {};
        }
    }
    const getMaxCapacityHasBeenReached = () => {
        return studentList.length === Number(resource.capacity);
    } 
    const getTitleOfDialogTakeStudentsAttendanceConfirmation = () => {
        if (selectedStudents.length === 1)
            return TITLES_OF_DIALOG_CONFIRMATION.TAKE_STUDENT_ATTENDANCE.ONE_STUDENT;
        if (selectedStudents.length === studentList.length)
            return TITLES_OF_DIALOG_CONFIRMATION.TAKE_STUDENT_ATTENDANCE.ALL_STUDENTS;
        return TITLES_OF_DIALOG_CONFIRMATION.TAKE_STUDENT_ATTENDANCE.SOME_STUDENTS;
    }
    //#endregion
    //#region Custom hooks
    const { 
        actionTypeList,
        actionTypeOfNoActionForHaveAttendanceOrPenalty
    } = useActionTypes({
        setMustConfirm
    });
    const getPropsDialogShowNotActionForHaveAttendanceOrPenalty = () => {
        if (!actionTypeOfNoActionForHaveAttendanceOrPenalty.value) return {};
        const props = ({
            [ACTION_TYPES.PENALIZE]: {
                title: "No se puede sancionar a todos los alumnos",
                subtitle: "Actualmente cuentan con una sanción registrada:",
                students: studentsWithRegisteredPenalty
            },
            [ACTION_TYPES.DELETE]: {
                title: "No se puede eliminar a todos los alumnos",
                subtitle: "Actualmente cuentan con asistencia o sanción:",
                students: studentsWithPenaltyOrAttendanceForDeletion
            }
        })[actionTypeOfNoActionForHaveAttendanceOrPenalty.value];
        return {
            dialog: dialogShowNotActionForHavingAttendanceOrPenalty,
            title: props.title,
            contentComponent: (
                <DialogContentNotActionForSomeStudentsHaveAttendanceOrPenalty
                    showDialog={dialogShowNotActionForHavingAttendanceOrPenalty.value}
                    students={props.students}
                    subtitle={props.subtitle}/>
            ),
            buttons: (
                <CustomButton 
                    width="120px"
                    text="Cerrar"
                    onClick={dialogShowNotActionForHavingAttendanceOrPenalty.hide}/>
            )
        };
    }
    const addActionTypeToListActions = actionTypeList.add;
    const { 
        fns: {
            openTakeStudentAttendanceDialog,
            takeStudentAttendance,
            doRequestTakeStudentAttendance
        },
        dialogs: {
            dialogShowTakeStudentsAttendanceConfirmation
        }
    } = useTakeStudentsAttendance({
        students: {
            studentList,
            setStudentList,
            selectedStudents,
            setSelectedStudents
        },
        addActionTypeToListActions,
        setResolveType,
        loadingRequest
    });
    const { 
        penalizeForm, 
        formList, 
        dialogs: {
            dialogShowNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties,
            dialogShowPenalizeDialog
        },
        fns: {
            openPenalizeStudentDialog,
            setPenalizeValueForm,
            penalizeStudentFromReservationList,
            doRequestPenalizeStudents,
            getIsForUpdatePenalty,
            getInfoTooltipOfPenalize
        },
        studentsWithRegisteredPenalty
    } = usePenalizedStudents({
        students: {
            studentList,
            setStudentList,
            selectedStudents,
            setSelectedStudents
        },
        dialogs: {
            dialogShowNotActionForHavingAttendanceOrPenalty
        },
        penalizeData,
        setActionTypeOfNoActionForHaveAttendanceOrPenalty: actionTypeOfNoActionForHaveAttendanceOrPenalty.set,
        addActionTypeToListActions,
        loadingRequest
    });
    const {
        studentReservationDetailIdsToDelete,
        studentsWithPenaltyOrAttendanceForDeletion,
        fns: {
            deleteStudentFromReservationList,
            openDeleteStudentDialog,
            doRequestDeleteStudentFromReservationList,
        },
        dialogs: {
            dialogShowDeleteStudentsConfirmation,
            dialogShowNotDeleteForLessThan2StudentsRemaining
        }
    } = useDeleteStudents({
        students: {
            studentList, 
            setStudentList, 
            setStudentsSelectedToUse,
            selectedStudents,
            setSelectedStudents
        },
        dialogs: {
            dialogShowResolveRequest,
            dialogShowNotActionForHavingAttendanceOrPenalty
        },
        setSuccessToDoActionOnStudent,
        setActionTypeOfNoActionForHaveAttendanceOrPenalty: actionTypeOfNoActionForHaveAttendanceOrPenalty.set,
        addActionTypeToListActions,
        setResolveType,
        loadingRequest
    });
    const {
        fns: { 
            addStudentToReservationList,
            confirmAddStudent,
            doRequestAddStudentToReservationList
        },
        dialogs: {
            dialogShowAddStudentConfirmation
        }
    } = useAddStudent({
        reservationId: id,
        students: {
            studentList, 
            setStudentList, 
            studentsSelectedToUse,
            setStudentsSelectedToUse
        },
        dialogs: {
            dialogShowResolveRequest
        },
        addActionTypeToListActions,
        setSuccessToDoActionOnStudent,
        setResolveType,
        loadingRequest
    });
    useRemoveScrollByDialogs([
        mainContext.showDialogUnexpectedError,
        dialogShowPenalizeDialog.value,
        dialogShowResolveRequest.value,
        dialogShowNotActionForHavingAttendanceOrPenalty.value,
        dialogShowNotDeleteForLessThan2StudentsRemaining.value,
        dialogShowNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties.value,
        dialogShowDeleteStudentsConfirmation.value
    ]);
    useEffect(() => {
        if (!studentList.some(({ forTakeAttendance }) => forTakeAttendance))
            actionTypeList.remove(ACTION_TYPES.TAKE_ATTENDANCE);
        if (studentReservationDetailIdsToDelete.length === 0)
            actionTypeList.remove(ACTION_TYPES.DELETE);
        if (!studentList.some(({ saved }) => !saved))
            actionTypeList.remove(ACTION_TYPES.ADD);
    }, [dialogShowResolveRequest.value]);
    //#endregion
    return (
        <>
        <Column gap="10px">
            <Title title="Listado de alumnos">Listado de alumnos</Title>
            <StudentTableList 
                data={studentList}
                formList={formList}
                studentsSelected={{
                    toggle: toggleStudentSelected,
                    isSelected: studentIsSelected,
                    allAreSelected: allStudentAreSelected,
                    toggleAllSelected: toggleAllStudentsSelection
                }}
                getInfoTooltipOfPenalize={getInfoTooltipOfPenalize}/>
            <ActionButtons 
                studentList={studentList}
                selectedStudents={selectedStudents}
                forValidations={{
                    getHasBeenSelectedResponsableStudent, 
                    getMaxCapacityHasBeenReached
                }}
                getIsForUpdatePenalty={getIsForUpdatePenalty}
                notActions={actionTypeList.value.length === 0}
                finalized={finalized}
                actions={{
                    openTakeStudentAttendanceDialog,
                    openPenalizeStudentDialog,
                    openDeleteStudentDialog,
                    openAddStudentDialog: () => dialogShowSearchStudent.set(true),
                    openSaveInformationDialog: () => dialogShowSaveInformation.set(true),
                }}/>
        </Column>
        <DialogSearchStudent 
            loadingRequest={loadingRequest}
            dialogShow={dialogShowSearchStudent}
            changeStudent={confirmAddStudent}/>
        <PenalizeDialog 
            dialogShow={dialogShowPenalizeDialog}
            form={penalizeForm.value}
            setForm={setPenalizeValueForm}
            penalty={{
                data: penalizeData,
                value: penalizeForm.update
            }}
            applyPenalty={penalizeStudentFromReservationList}/>
        {renderDialogAction({
            dialog: dialogShowAddStudentConfirmation,
            title: `¿Deseas agregar al alumno ${studentsSelectedToUse[0]?.id} (${studentsSelectedToUse[0]?.name})
            de la reserva del recurso ${resource.name}?`,
            content: "Recuerda que al agregar un alumno, podrás visualizarlo nuevamente en el listado de alumnos.",
            buttons: (
                <>
                    <CustomButton 
                        variant="secondary" 
                        width="120px"
                        text="No, cancelar"
                        onClick={() => dialogShowAddStudentConfirmation.set(false)}/>
                    <CustomButton 
                        width="120px"
                        text="Si, agregar"
                        onClick={addStudentToReservationList}/>
                </>
            )
        })}
        {renderDialogAction({
            dialog: dialogShowDeleteStudentsConfirmation,
            title: `¿Deseas eliminar ${selectedStudents.length === 1 ? "al alumno" : "a los alumnos"} de la reserva
            del recurso ${resource.name}?`,
            content: "Recuerda que al eliminar un alumno, podrás agregarlo nuevamente a esta u otra reserva desde el botón Agregar alumno(s).",
            buttons: (
                <>
                    <CustomButton 
                        variant="secondary" 
                        width="120px"
                        text="No, cancelar"
                        onClick={() => dialogShowDeleteStudentsConfirmation.set(false)}/>
                    <CustomButton 
                        width="120px"
                        text="Si, eliminar"
                        onClick={deleteStudentFromReservationList}/>
                </>
            )
        })}
        {renderDialogAction({
            dialog: dialogShowTakeStudentsAttendanceConfirmation,
            title: getTitleOfDialogTakeStudentsAttendanceConfirmation(),
            content: "Recuerda que al marcar la asistencia de un alumno, ya no podrás eliminarlo de la reserva.",
            buttons: (
                <>
                <CustomButton 
                    variant="secondary" 
                    width="120px"
                    text="No, cancelar"
                    onClick={() => dialogShowTakeStudentsAttendanceConfirmation.set(false)}/>
                <CustomButton 
                    width="120px"
                    text="Si, aceptar"
                    onClick={takeStudentAttendance}/>
                </>
            )
        })}
        {renderDialogAction({
            dialog: dialogShowSaveInformation,
            title: "¿Deseas guardar los cambios?",
            content: "Recuerda que al guardar los cambios, podrás visualizarlos al ingresar nuevamente al listado de alumnos.",
            buttons: (
                <>
                <CustomButton 
                    variant="secondary" 
                    width="120px"
                    text="No, cancelar"
                    onClick={() => dialogShowSaveInformation.set(false)}/>
                <CustomButton 
                    width="120px"
                    text="Si, guardar"
                    onClick={saveInformation}/>
                </>
            )
        })}
        {renderDialogAction({
            dialog: dialogShowResolveRequest,
            ...getHeaderTextsForDialogResolve(),
            buttons: (
                <CustomButton   
                    width="120px"
                    text="Cerrar" 
                    onClick={() => dialogShowResolveRequest.set(false)}/>
            )
        })}
        {renderDialogAction({
            dialog: dialogShowNotDeleteForLessThan2StudentsRemaining,
            title: "No se puede eliminar a los alumnos seleccionados",
            content: "Recuerda que las reservas de salas grupales deben tener un mínimo de dos alumnos.",
            buttons: (
                <CustomButton 
                    width="120px"
                    text="Cerrar"
                    onClick={() => dialogShowNotDeleteForLessThan2StudentsRemaining.set(false)}/>
            )
        })}
        {renderDialogAction({
            dialog: dialogShowNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties,
            title: "No se puede editar las sanciones de todos los alumnos",
            content: "Actualmente hay más de un alumno con una sanción distinta.",
            buttons: (
                <CustomButton 
                    width="120px"
                    text="Cerrar"
                    onClick={() => dialogShowNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties.set(false)}/>
            )
        })}
        {renderDialogAction(getPropsDialogShowNotActionForHaveAttendanceOrPenalty())}
        </>
    );
}

const DialogContentNotActionForSomeStudentsHaveAttendanceOrPenalty = ({
    showDialog,
    students,
    subtitle
}) => {
    if (!showDialog) 
        return null;
    return (
        <>
        <p className="paragraph center">{subtitle}</p>
        <Column className="custom-scrollbar secondary"
            maxHeight="150px"
            align="center">
            <ul className="list paragraph center">
                {students
                .map(({ id, name }) => (
                    <li key={id}>{id} ({name})</li>
                ))}
            </ul>
        </Column>
        </>
    );
}

export default StudentListReservationView;